import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NoData from '@/components/NoData/NoData';
import { valsubstr32addbr } from '@/utils/index';
export default {
  components: {
    NoData: NoData
  },
  data: function data() {
    return {
      visible: false,
      currentPage: 1,
      loading: false,
      tableheight: 512,
      isIndeterminate: false,
      pageshow: true,
      totalrecord: 0,
      headerName: '新增用户群组',
      group: {
        userGroupName: null,
        groupDescribe: null,
        userIds: null,
        id: null
      },
      rules: {
        userGroupName: [{
          required: true,
          message: '请输入用户群组',
          trigger: 'blur'
        }],
        groupDescribe: []
      },
      adduserErrorList: [],
      edituserValue: null,
      edituserList: [],
      userList: [],
      id: null,
      isShow: false
    };
  },
  created: function created() {
    // 获取路由里面的type参数
    this.id = this.$route.query.id;
    if (this.id) {
      this.headerName = '编辑用户群组';
      this.getData();
      this.getUsers();
    }
  },
  computed: {
    rootOrgId: function rootOrgId() {
      return this.$HEXASINO.rootOrgId;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.tableheight = window.innerHeight - 402;

      // 监听窗口大小变化
      var self = this;
      window.onresize = function () {
        self.tableheight = window.innerHeight - 402;
      };
    });
  },
  methods: {
    getData: function getData() {
      var _this = this;
      this.loading = true;
      this.$API.getRequest({
        url: '/platform/userGroup/searchUserGroupDetail',
        data: {
          userGroupId: this.id
        }
      }).then(function (res) {
        _this.loading = false;
        if (res.code === '0000000000') {
          _this.group = res.result;
          _this.group.id = _this.id;
        }
      });
    },
    getUsers: function getUsers() {
      var _this2 = this;
      this.loading = true;
      this.$API.postRequest({
        url: '/platform/userGroup/searchUserGroupRefPage',
        data: {
          pageNum: 1,
          pageSize: -1,
          userGroupIds: [this.id]
        }
      }).then(function (res) {
        _this2.loading = false;
        if (res.code === '0000000000') {
          _this2.userList = res.result.records;
        }
      });
    },
    addUsers: function addUsers() {
      var _this3 = this;
      if (!this.edituserValue) {
        this.visible = false;
      } else {
        var edituserList = [];
        edituserList = this.edituserValue.split('\n');
        if (!edituserList[edituserList.length - 1]) {
          edituserList.pop();
        }
        var repeatData = this.userList.filter(function (item) {
          return edituserList.indexOf(item.userId) > -1;
        });
        if (repeatData.length) {
          this.$message({
            message: "\u4EBA\u5458\"".concat(repeatData.map(function (item) {
              return item.userName;
            }).join(), "\"\u91CD\u590D!"),
            type: 'error'
          });
          return;
        }
        this.loading = true;
        this.$API.postRequest({
          url: '/platform/user/getUserByUserIdList',
          data: edituserList
        }).then(function (res) {
          _this3.loading = false;
          if (res.code === '0000000000') {
            _this3.userList = _this3.userList.concat(res.result);
            _this3.loading = false;
            _this3.visible = false;
            _this3.adduserErrorList = [];
            _this3.edituserValue = null;
          }
        }, function (err) {
          _this3.adduserErrorList = [];
          if (err.error && err.error.message) {
            _this3.adduserErrorList.push(err.error.message);
            if (!_this3.adduserErrorList.length) {
              _this3.$message({
                message: err.error.msg || '请输入正确的用户编号！',
                type: 'error'
              });
            }
          } else {
            _this3.$message({
              message: err.error.msg || '请输入正确的用户编号！',
              type: 'error'
            });
          }
          _this3.loading = false;
        });
      }
    },
    addUsersByOrg: function addUsersByOrg(users) {
      var _this4 = this;
      var userIds = users.map(function (item) {
        return item.userId;
      });
      var repeatData = this.userList.filter(function (item) {
        return userIds.indexOf(item.userId) > -1;
      });
      if (repeatData.length) {
        this.$message({
          message: "\u4EBA\u5458\"".concat(repeatData.map(function (item) {
            return item.userName;
          }).join(), "\"\u91CD\u590D!"),
          type: 'error'
        });
        return;
      }
      this.loading = true;
      this.$API.postRequest({
        url: '/platform/user/getUserByUserIdList',
        data: userIds
      }).then(function (res) {
        _this4.loading = false;
        if (res.code === '0000000000') {
          _this4.userList = _this4.userList.concat(res.result);
          _this4.loading = false;
          _this4.isShow = false;
        }
      });
    },
    submit: function submit() {
      var _this5 = this;
      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          if (!_this5.userList || !_this5.userList.length) {
            _this5.$message({
              message: '请录入成员',
              type: 'error'
            });
            return;
          }
          _this5.loading = true;
          var url;
          var sucText;
          if (_this5.id) {
            url = '/platform/userGroup/editUserGroup';
            sucText = '编辑成功！';
          } else {
            url = '/platform/userGroup/addUserGroup';
            sucText = '创建成功！';
          }
          var userIds = _this5.userList.map(function (item) {
            return item.userId;
          });
          _this5.group.userIds = userIds;
          _this5.$API.postRequest({
            url: url,
            data: _this5.group
          }).then(function (res) {
            _this5.loading = false;
            if (res.code === '0000000000') {
              _this5.$message({
                message: sucText,
                type: 'success'
              });
              _this5.loading = false;
              _this5.back();
            }
          });
        }
      });
    },
    deleteUser: function deleteUser(index) {
      this.userList.splice(index, 1);
    },
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    },
    headerdragend: function headerdragend(newWidth, oldWidth, column) {
      if (newWidth < column.minWidth) {
        column.width = column.minWidth;
      }
    },
    back: function back() {
      this.$router.push('/system/usergroup');
    }
  }
};